<template>
  <span
    :class="{
      'd-none': true,
      [`dsp-${hint}`]: true,
    }"
    >{{ JSON.stringify(toStore).substring(0, 0) }}</span
  >
</template>

<script lang="ts" setup>
// A component to persist data to the payload (e.g. ptcDebug.payload.data)
defineProps<{
  toStore: object;
  hint: string;
}>();
</script>
